import { render } from "./ManageKRIModal.vue?vue&type=template&id=36447976&scoped=true"
import script from "./ManageKRIModal.js?vue&type=script&lang=js"
export * from "./ManageKRIModal.js?vue&type=script&lang=js"

import "./ManageKRIModal.vue?vue&type=style&index=0&id=36447976&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36447976"]])

export default __exports__